import React from "react";
var SocialMediaLinks = function SocialMediaLinks(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/React.createElement("div", {
    className: "social-media-links"
  }, links.map(function (link) {
    var _link$link = link.link,
      content = _link$link.content,
      href = _link$link.href;
    return /*#__PURE__*/React.createElement("a", {
      key: "social-media".concat(content),
      title: content,
      href: href,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("i", {
      className: "social-media-icon ".concat(content.toLowerCase())
    }));
  }));
};
export default SocialMediaLinks;